import StoniTenis from './StoniTenis'

const OdbojkaNaPesku = () => <StoniTenis calculatorType='Odbojka na pesku' />

export default OdbojkaNaPesku
